import React from 'react';
// import frontendImg from '../../images/front-end.png';
import backendImg from '../../images/backend.png';
// import uiImg from '../../images/design.png';
// import appsImg from '../../images/apps.png';
import maya from '../../images/maya.svg';
import comvis from '../../images/comvis.svg';
import htmlIcon from '../../images/html.svg';
import data from '../../images/data.svg';
import cloud from '../../images/cloud.svg'

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { icon } from '@fortawesome/fontawesome-svg-core/import.macro'

// import { icon } from '@fortawesome/fontawesome-svg-core/import.macro'
// // Specify all properties: name, family, style
// icon({name: 'user', family: 'classic', style: 'solid'})
// icon({name: 'user', family: 'classic', style: 'regular'})
// icon({name: 'twitter', family: 'classic', style: 'brands'})

// // 'classic' is the default family, you can leave that off
// icon({name: 'user', style: 'solid'})
// icon({name: 'user', style: 'regular'})
// icon({name: 'twitter', style: 'brands'})

// // 'solid' is the default style, you can leave that off
// icon({name: 'user'})

// module.exports = function (api) {
//   return {
//     plugins: ['macros'],
//   }
// }
// module.exports = {
//   'fontawesome-svg-core': {
//     'license': 'free'
//   }
// }

const Services = () => {
    return (
        <section id="services">
            <div className='container lg:pt-5'>
                <div className='text-center'>
                    <h2 className='text-headingColor font-[800] text-[2.4rem] mb-5'>Skill Set</h2>
                    <p className='lg:max-w-[600px] lg:max-auto justify-between text-headingcolor font-[500] text-[16px] leading-7 '></p>
                </div>

                <div className='flex flex-col justify-center sm:py-12'>
                    <div className='w-full py-3 px-2 sm:max-w-xl sm:mx-auto sm:px-0'>
                        <div className='relative text-gray-700 antialiased text-sm font-semibold'>
                            {/* vertical line  */}
                            <div className='hidden absolute w-1 sm:block bg-indigo-300 h-full left-1/2 transform-translate-x-1/2'></div>


                            {/* left card */}
                            <div className='mt-6 sm:mt-0 sm:mb-12'>
                                <div className='flex items-center flex-col sm:flex-row'>
                                    <div className='flex justify-start w-full mx-auto items-center'>
                                        <div className='w-full sm:w-1/2 sm:pr-8'>
                                        
                                            <div data-aos='fade-right' data-aos-duration='1200' className=' p-4 bg-white rounded group shadow-xl
                                        cursor-pointer ease-in duration-150'>
                                            <h3 className='flex items-center text-[20px]'><img className='h-[40px] w-[40px] items-center ml-16 mr-7' src={cloud} alt='Cloud Computing'></img>Cloud Computing</h3>
                                                 {/* <h3 className='text-primaryColor font-[700] text-center mt-3 mb-3 group-hover:text-white group-hover:font[600] text-xl'> */}
                                                    {/* Java */}
                                                    {/* <FontAwesomeIcon icon="fa-brands fa-java" /></h3> */}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='rounded-full bg-black border-white border-4 w-10 h-10 absolute left-1/2
                                transform -translate-x-1/2 -translate-y-4 sm:translate-y-0 flex items-center justify-center'>
                                        <figure><img src={backendImg} alt='' /></figure>
                                    </div>
                                    
                                </div>
                                
                            </div>

                            {/* right card */}
                            <div className='mt-6 sm:mt-0 sm:mb-12'>
                                <div className='flex items-center flex-col sm:flex-row'>
                                    <div className='flex justify-end w-full mx-auto items-center'>
                                        <div className='w-full sm:w-1/2 sm:pl-8'>
                                            <div data-aos='fade-left' data-aos-duration='1200' className='bg-white p-4 rounded group shadow-xl
                                        cursor-pointer ease-in duration-150'>
                                                 <h3 className='flex items-center text-[20px] '><img className='h-[40px] w-[40px] items-center ml-10 mr-5' src={maya} alt='3D Design'></img>3D Design</h3>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='rounded-full bg-black border-white border-4 w-10 h-10 absolute left-1/2
                                transform -translate-x-1/2 -translate-y-4 sm:translate-y-0 flex items-center justify-center'>
                                        <figure><img src={backendImg} alt='' /></figure>
                                    </div>
                                </div>
                            </div>

                            {/* left card */}
                            <div className='mt-6 sm:mt-0 sm:mb-12'>
                                <div className='flex items-center flex-col sm:flex-row'>
                                    <div className='flex justify-start w-full mx-auto items-center'>
                                        <div className='w-full sm:w-1/2 sm:pr-8'>
                                            <div data-aos='fade-right' data-aos-duration='1200' className='bg-white p-4 rounded group shadow-xl 
                                        cursor-pointer ease-in duration-150'>
                                                 <h3 className='flex items-center text-[20px] '><img className='h-[40px] w-[40px] items-center ml-12 mr-5' src={comvis} alt='Artificial Intelligence'></img>Artificial Intelligence</h3>
                                                 {/* <h3 className='text-primaryColor font-[700] text-center mt-3 mb-3 group-hover:text-white group-hover:font[600] text-xl'> */}
                                                    {/* Java */}
                                                    {/* <i class="ri-javascript-fill"></i></h3> */}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='rounded-full bg-black border-white border-4 w-10 h-10 absolute left-1/2
                                transform -translate-x-1/2 -translate-y-4 sm:translate-y-0 flex items-center justify-center'>
                                        <figure><img src={backendImg} alt='' /></figure>
                                    </div>
                                </div>
                            </div>

                            {/* right card */}
                            <div className='mt-6 sm:mt-0 sm:mb-12'>
                                <div className='flex items-center flex-col sm:flex-row'>
                                    <div className='flex justify-end w-full mx-auto items-center'>
                                        <div className='w-full sm:w-1/2 sm:pl-8'>
                                            <div data-aos='fade-left' data-aos-duration='1200' className='bg-white p-4 rounded group shadow-xl
                                        cursor-pointer ease-in duration-150'>
                                                 <h3 className='flex items-center text-[20px] '>
                                                    <svg className='h-[40px] w-[40px] items-center ml-14 mr-5' viewBox='0 0 24 24' fill='#3DDC84' xmlns='http://www.w3.org/2000/svg'>
                                                        <path d='M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z'/>
                                                    </svg>
                                                    Android
                                                 </h3>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='rounded-full bg-black border-white border-4 w-10 h-10 absolute left-1/2
                                transform -translate-x-1/2 -translate-y-4 sm:translate-y-0 flex items-center justify-center'>
                                        <figure><img src={backendImg} alt='' /></figure>
                                    </div>
                                </div>
                            </div>

                            {/* left card - SQL */}
                            <div className='mt-6 sm:mt-0 sm:mb-12'>
                                <div className='flex items-center flex-col sm:flex-row'>
                                    <div className='flex justify-start w-full mx-auto items-center'>
                                        <div className='w-full sm:w-1/2 sm:pr-8'>
                                            <div data-aos='fade-right' data-aos-duration='1200' className='bg-white p-4 rounded group shadow-xl
                                        cursor-pointer ease-in duration-150'>
                                                 <h3 className='flex items-center text-[20px]'><img className='h-[40px] w-[40px] items-center ml-14 mr-5' src={data} alt='SQL'></img>SQL</h3>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='rounded-full bg-black border-white border-4 w-10 h-10 absolute left-1/2
                                transform -translate-x-1/2 -translate-y-4 sm:translate-y-0 flex items-center justify-center'>
                                        <figure><img src={backendImg} alt='' /></figure>
                                    </div>
                                </div>
                            </div>

                            {/* right card - Web Developer */}
                            <div className='mt-6 sm:mt-0 sm:mb-12'>
                                <div className='flex items-center flex-col sm:flex-row'>
                                    <div className='flex justify-end w-full mx-auto items-center'>
                                        <div className='w-full sm:w-1/2 sm:pl-8'>
                                            <div data-aos='fade-left' data-aos-duration='1200' className='bg-white p-4 rounded group shadow-xl
                                        cursor-pointer ease-in duration-150'>
                                                 <h3 className='flex items-center text-[20px] '><img className='h-[40px] w-[40px] items-center ml-10 mr-5' src={htmlIcon} alt='Web Developer'></img>Web Developer</h3>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='rounded-full bg-black border-white border-4 w-10 h-10 absolute left-1/2
                                transform -translate-x-1/2 -translate-y-4 sm:translate-y-0 flex items-center justify-center'>
                                        <figure><img src={backendImg} alt='' /></figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Services;